module.exports = "/_next/static/images/e742297a8ce9a42a2029707a04d7ef11-card-wait-notice.svg";